import C_GameEvent from "../const/C_GameEvent";

/**
 * Scene manager.
 * Uses the abstraction of a view - a display object container (BaseView) which has many components inside.
 */
class ViewManager
{


    constructor()
    {
        this.currentView = null;
        this.app = PIXI.app;
    }


    /**
     * Add a view to the scene and remove the current one
     * @param viewClass
     */
    setView(viewClass)
    {
        if (this.currentView != null)
        {
            this.app.stage.removeChild(this.currentView);
        }

        this.currentView  = new viewClass();
        this.app.stage.addChild(this.currentView);

        this.app.dispatcher.emit(C_GameEvent.NAVIGATE);
    }


    /**
     * Adds an extra view on top of the current view
     * @param viewClass
     */
    addView(viewClass, params)
    {
        this.runDiag();

        if (this.currentView != null)
        {
            TweenMax.to(this.currentView, .25, {delay:.25, visible:false});
        }

        this.removeView();


        this.overView = params == undefined ? new viewClass() : new viewClass(params);
        this.app.stage.addChild(this.overView);
        TweenMax.from(this.overView, .25, {alpha:0});
    }


    removeView()
    {
        if (this.currentView != null)
        {
            TweenMax.killTweensOf(this.currentView);
            this.currentView.visible = true;
        }

        if (this.overView)
        {
            TweenMax.to(this.overView, .25, {alpha:0,
                onComplete:this.overView.removeFromParent, onCompleteParams:[], onCompleteScope:this.overView});
            this.overView = null;
        }
    }


    addOverlay(pos, color, width, height)
    {
        this.overlay = new PIXI.Graphics();
        // overlay.beginFill(0x000000);
        this.overlay.beginFill(color);
        this.overlay.drawRect(0, 0, this.app.layout.relWidth(width), this.app.layout.relHeight(height));
        this.app.stage.addChild(this.overlay);

        return this.overlay;
    }


    getOverlay()
    {
        return this.overlay;
    }


    removeOverlay()
    {
        if (this.overlay)
        {
            if (this.overlay.parent)
            {
                this.overlay.parent.removeChild(this.overlay);
            }
        }
    }


    runDiag()
    {
        console.log("Num children : " + this.getNumChildren(this.app.stage));
    }


    getNumChildren(parent)
    {
        let numChildren = 1;
        if (parent.children)
        {
            for (let childIdx = 0; childIdx < parent.children.length; childIdx++)
            {
                numChildren += this.getNumChildren(parent.children[childIdx]);
            }
        }
        return numChildren;
    }


}


export default ViewManager;